module.exports = __webpack_public_path__ + "static/media/wn.d7e94857.png";